import React from 'react';
import {EntityProvider} from "./entity-provider";
import {EntityRouter} from "./entity-router";

export function EntityWrapper(props) {

    return <EntityProvider {...props}>
        <EntityRouter {...props} />
    </EntityProvider>
}